import React from 'react';

import './_header.css';

const Header: React.SFC = () => (
  <header>
    <h1>Bellingham Bikes</h1>
  </header>
);

export default Header;
